module.exports = __webpack_public_path__ + "img/08.8244367d.png";